/* eslint-disable import/no-cycle */
import {APP_DEFINITION_ID, StoresWidgetID} from '@wix/wixstores-client-core/dist/es/src/constants';

export const translationPath = (baseUrl, locale) => `${baseUrl}assets/locale/gallery/gallery_${locale}.json`;
export const RELATED_PRODUCTS_PRODUCT_ID_WARMUP_KEY = 'relatedProductsProductId';
export const DEFAULT_COLLECTION_ID = '00000000-000000-000000-000000000001';
export const TRACK_EVENT_COLLECTION = 'All Products';
export const BI_APP_NAME = 'galleryApp';
export const GALLERY_FEDOPS_APP_NAME = 'wixstores-gallery';
export const SLIDER_GALLERY_FEDOPS_APP_NAME = 'wixstores-slider-gallery';
export const origin = 'gallery-page';
export const MAX_PRODUCTS = 10000;
export const MAX_PRODUCTS_BATCHING = 2000;
export const SLIDER_GALLERY_TYPE = 'slider-gallery';

export const DEFAULT_GALLERY_IMAGE_SIZE = 100;

export const DASHBOARD_PAGE_ID = '0da20375-5aad-400a-abcb-e50e17308306';

export enum SLIDER_GALLERY_PRODUCTS_LOGICS_FOR_BI {
  RELATED_PRODUCTS = 'related products',
  COLLECTION = 'collection',
  ALL_PRODUCTS = 'All products',
  VELO = 'velo products',
  ALGORITHMS = 'algorithms',
}

export enum PAGE_NAMES_FOR_BI {
  HOME = 'home',
  CUSTOM_PAGE = 'custom_page',
}

export enum GALLERY_PUBLIC_DATA_PRESET_ID {
  COLLECTION = 'Wix_Store_Slider_Product_Gallery_1',
  RELATED_PRODUCTS = 'Wix_Store_Related_Product_Gallery_1',
}

export enum FilterAndSortButtonStyle {
  TEXT,
  BOX,
}

export interface IKeyboardEvent {
  keyCode: number;
  charCode: number;
}

export const keyboardEvents: {[key: string]: IKeyboardEvent} = {
  ENTER: {keyCode: 13, charCode: 13},
  SPACEBAR: {keyCode: 32, charCode: 32},
  ARROW_UP: {keyCode: 38, charCode: 38},
  ARROW_DOWN: {keyCode: 40, charCode: 40},
  ARROW_RIGHT: {keyCode: 39, charCode: 39},
  ARROW_LEFT: {keyCode: 37, charCode: 37},
};

export const MAX_COLS = 6;
export const MAX_ROWS = 12;
export const DEFAULT_COLS = 4;
export const DEFAULT_ROWS = 5;
export const DEFAULT_MOBILE_PRODUCTS_COUNT = 10;
export const DEFAULT_AUTO_GRID_PRODUCTS_COUNT = 24;
export const DEFAULT_MANUAL_GRID_PRODUCTS_COUNT = DEFAULT_COLS * DEFAULT_ROWS;
export const DEFAULT_PRODUCT_IMAGE_SIZE = 240;
export const BATCH_MAX_SIZE = 100;

export enum Experiments {
  ClientGalleryArrowlessMobileSlider = 'specs.stores.ClientGalleryArrowlessMobileSlider',
  AllowGalleryProductRoundCornersInViewer = 'specs.stores.AllowGalleryProductRoundCornersInViewer',
  GalleryProductItemCarouselHover = 'specs.stores.GalleryProductItemCarouselHover',
  SliderGalleryInEditorXViewer = 'specs.stores.SliderGalleryInEditorXViewer',
  EditableGridTemplateRepeatOption = 'specs.stores.GalleryEditableGridTemplateRepeatOption',
  EditorGalleryOOI = 'specs.stores.EditorGalleryOOI',
  ClearFiltersInASingleCall = 'specs.stores.GalleryClearFiltersInASingleCall',
  FixQuickViewForSubscriptionsInWishlist = 'specs.stores.FixQuickViewForSubscriptionsInWishlist',
  RenderSlotsInGallery = 'specs.stores.RenderSlotsInGallery',
  EnableQualityOptionsStylingChanges = 'specs.stores.EnableQualityOptionsStylingChanges',
  GalleryProductOptionsLimit = 'specs.stores.GalleryProductOptionsLimit',
  EnableDynamicSizeDefaultImage = 'specs.stores.EnableDynamicSizeDefaultImage',
  AllowAddToCartButtonOnImageInViewer = 'specs.stores.AllowAddToCartButtonOnImageInViewer',
  AllowAddToCartButtonContentTypesInViewer = 'specs.stores.AllowAddToCartButtonContentTypesInViewer',
  SendSubcategoriesSeoDataSF = 'specs.stores.SendSubcategoriesSeoDataSF',
  SendSubcategoriesSeoNewItemTypeSF = 'specs.stores.SendSubcategoriesSeoNewItemTypeSF',
  EnableDiscountAndRegularPriceSwapViewer = 'specs.stores.EnableDiscountAndRegularPriceSwapViewer',
  EnableOutOfStockAlignment = 'specs.stores.EnableOutOfStockAlignment',
  AddMobileClassesToSliderGalleryRoot = 'specs.stores.AddMobileClassesToSliderGalleryRoot',
  ShouldPreloadCurrentCart = 'specs.stores.ShouldPreloadCurrentCart',
  EnableLoadableGallery = 'specs.stores.EnableGalleryLoadable',
  GalleryProductOptionsAndQuantityWidth = 'specs.stores.GalleryProductOptionsAndQuantityWidth',
  UseGalleryNewApplyFilterQueryParams = 'specs.stores.UseGalleryNewApplyFilterQueryParams',
  RepeatedSlots = 'specs.stores.GalleryRepeatedSlots',
  GalleryColorPickerA11yReflowKeyboardFix = 'specs.stores.GalleryColorPickerA11yReflowKeyboardFix',
  GalleryFreemodeNavigation = 'specs.stores.AllowGalleryFreeModeNavigationInViewer',
  NewClearFiltersHoverState = 'specs.stores.newClearFiltersHoverState',
  GalleryIntervalNavigation = 'specs.stores.AllowGalleryIntervalNavigation',
  SliderFixRtlTeaserOffset = 'specs.stores.SliderFixRtlTeaserOffset',
  LoadClientConfigInController = 'specs.stores.LoadClientConfigInController',
  GalleryProductOptionsTextualOptionType = 'specs.stores.allowProductPageButtonsOption',
  EnableWarmUpDataCaching = 'specs.stores.EnableWarmUpDataCaching',
  GalleryFixWarmUpDataCacheKeyWithQueryParams = 'specs.stores.GalleryFixWarmUpDataCacheKeyWithQueryParams',
  FixFilterKeySpecialCharacter = 'specs.stores.FixFilterKeySpecialCharacter',
  ShouldShowFirstProductOptionInGallery = 'specs.stores.ShouldShowFirstProductOptionInGallery',
  GallerySet404ForSeoWhenPageHasNoProducts = 'specs.stores.Set404ForSeoWhenPageHasNoProducts',
  AddSliderGalleryTitleToGlobalPropsContext = 'specs.stores.AddSliderGalleryTitleToGlobalPropsContext',
  FixWishlistPageLiveTextEditing = 'specs.stores.FixWishlistPageLiveTextEditing',
  UseExperimentsFromPlatformFlowApi = 'specs.stores.UseExperimentsFromPlatformFlowApi',
  CategoryPageFooterDescriptionSF = 'specs.stores.CategoryPageFooterDescriptionSF',
  GalleryColorOptionAlignment = 'specs.stores.GalleryColorOptionAlignment',
  ResponsiveEditorBreadcrumbsToggle = 'specs.stores.ResponsiveEditorBreadcrumbsToggle',
  ProductNameHtmlTag = 'specs.stores.ProductNameHtmlTag',
  ShowWishlistInGallery = 'specs.stores.ShowWishlistInGallery',
  GalleryStoreExtractSEO = 'specs.stores.GalleryStoreExtractSEO',
  GalleryStoreExtractBI = 'specs.stores.GalleryStoreExtractBI',
  ShowErrorHandlingToastsGallery = 'specs.stores.ShowErrorHandlingToastsGallery',
  AddDiscountsToVariantsItemsQueries = 'specs.stores.AddDiscountsToVariantsItemsQueries',
  CombinedListing = 'specs.stores.CombinedListing',
  ShowPromotionsInGallery = 'specs.stores.ShowPromotionsInGallery',
  GalleryFilterChoicesGrouping = 'specs.stores.GalleryFilterChoicesGrouping',
  FixWishlistControllerConfigType = 'specs.stores.FixWishlistControllerConfigType',
  ShowMultiRibbonsInGallery = 'specs.stores.ShowMultiRibbonsInGallery',
  GalleryFixOutOfBoundsPageParam = 'specs.stores.GalleryFixOutOfBoundsPageParam',
  OnlineStoresCurrencyClientFormatting = 'specs.stores.OnlineStoresCurrencyClientFormatting',
  UseGetClientConfigFromPublicApi = 'specs.stores.UseGetClientConfigFromPublicApi',
  MoveCustomUrlApiToSiteStoreConstructor = 'specs.stores.MoveCustomUrlApiToSiteStoreConstructor',
  SwitchLocalStorageToSessionStorageInGalleryNavigationToPP = 'specs.stores.SwitchLocalStorageToSessionStorageInGalleryNavigationToPP',
  GalleryFixSideFiltersShrink = 'specs.stores.GalleryFixSideFiltersShrink',
  ShowFromTextOnFullSelectedVariant = 'specs.stores.ShowFromTextOnFullSelectedVariant',
  StorefrontSwatchImages = 'specs.stores.StorefrontSwatchImages',
  FixMigratedAllProductsInManualCategoryList = 'specs.stores.FixMigratedAllProductsInManualCategoryList',
  FixMultilingualTextInSF = 'specs.stores.FixMultilingualTextInSF',
  RelatedProductsSSRSlugLookup = 'relatedProductsSSRSlugLookup',
}

export enum FedopsInteraction {
  GridGalleryLoaded = 'grid-gallery-loaded',
  CategoryPageLoaded = 'category-page-loaded',
  SearchResultsGalleryLoaded = 'search-results-gallery-loaded',
  SearchModalGalleryLoaded = 'search-modal-gallery-loaded',
  SliderGalleryLoaded = 'slider-gallery-loaded',
  Filter = 'gallery-filter',
  Sort = 'gallery-sort',
  AddToCart = 'add-to-cart-from-gallery',
  LoadMore = 'load-more',
  Pagination = 'pagination',
  InfiniteScroll = 'infinite',
  EnrichProductWithItems = 'enrich-product-with-items',
  AddToWishlist = 'add-to-wishlist',
  RemoveFromWishlist = 'remove-from-wishlist',
  GetFilteredProducts = 'get-filtered-products',
}

export enum BiEventParam {
  LoadMore = 'button',
  Pagination = 'pagination',
  InfiniteScroll = 'infinite',
}

export enum TrackEvents {
  AddToCart = 'AddToCart',
  ViewContent = 'ViewContent',
  PromoCardImpression = 'PromoCardImpression',
  ClickPromoCard = 'ClickPromoCard',
}

export enum GalleryGridItemType {
  Product = 'product',
  Promotion = 'promotion',
}

export enum AddToCartActionStatus {
  IDLE = 0,
  SUCCESSFUL = 1,
  FAILED = 2,
  IN_PROGRESS = 3,
  UNSELECTED_OPTION_ERROR = 4,
}

export const trackEventMetaData = {
  appDefId: APP_DEFINITION_ID,
  category: 'All Products',
  origin: 'Stores',
} as const;

export const ProductOptionsDiplayLimit = {
  totalLimit: 2,
  colorPickersLimit: 1,
} as const;

const STORES_ALGORITHMS_APP_ID = '215238eb-22a5-4c36-9e7b-e7c08025e04e';

export const RelatedProductsAlgorithmData = {
  id: '68ebce04-b96a-4c52-9329-08fc9d8c1253',
  appId: STORES_ALGORITHMS_APP_ID,
};

export const STORES_GALLERY_SEO = 'STORES_GALLERY_COMPONENT';

export const STORES_CATEGORY_SEO = 'STORES_CATEGORY';
export const STORES_SUB_CATEGORY_SEO = 'STORES_SUB_CATEGORY';

export const STORES_NAMESPACE = 'stores';

export enum WixQueryParams {
  Lang = 'lang',
  Currency = 'currency',
}

export enum GalleryQueryParams {
  Sort = 'sort',
  Page = 'page',
}

export enum GALLERY_TYPE {
  COLLECTION = 1,
  RELATED_PRODUCTS = 2,
  VELO_PRODUCTS = 3,
  ALGORITHMS = 4,
}

export enum ProductBorderStyleType {
  INLINE = 1,
  OUTLINE = 2,
}

export enum FilterTypeForFetch {
  CATEGORY = 'CATEGORY',
  FILTERED_CATEGORIES = 'FILTERED_CATEGORIES',
  OPTIONS = 'OPTIONS',
  MODIFIERS = 'MODIFIERS',
  PRICE = 'PRICE',
}

export enum FilterTypeFromFetch {
  CATEGORY = 'CATEGORY',
  FILTERED_CATEGORIES = 'FILTERED_CATEGORIES',
  PRICE = 'PRICE',
  COLOR = 'OPTION_COLOR',
  LIST = 'OPTION_LIST',
}

export enum AutoGridTemplateRepeatOptions {
  AUTO_FIT = 'auto-fit',
  AUTO_FILL = 'auto-fill',
}

export enum CategoryListStrategy {
  AUTOMATICALLY = 0,
  MANUALLY = 1,
}

export enum CategoryListLayout {
  Vertical = 0,
  Horizontal = 1,
}

export enum CategoryListItemsToShow {
  ShowAll = 0,
  OnlyNested = 1,
}

export enum CategoryListHorizontalOverflow {
  Wrap = 0,
  Scroll = 1,
}

export enum CategoryListHorizontalPosition {
  AttachedToGallery = 0,
  AttachedToCategoryHeader = 1,
}
export enum CategoryListHorizontalButtonBorderType {
  None = 0,
  Underline = 1,
  Full = 2,
}

export enum CategoryHeaderPosition {
  MinimizedAboveGallery = 0,
  StretchedTop = 1,
}

export enum CategoryHeaderLayout {
  TextBelow = 0,
  TextInside = 1,
  TextAbove = 2,
}

export enum CategoryFooterDescriptionPosition {
  Inline = 0,
  Stretched = 1,
}

export enum GallerySlotIds {
  GalleryProductsTop = 'gallery-products-top',
  GalleryProductsBottom = 'gallery-products-bottom',
  CategoryPageListTop = 'category-page-list-top',
  GalleryFiltersTop = 'gallery-filters-top',
  GalleryFiltersBottom = 'gallery-filters-bottom',
  CategoryPageHeroTop = 'category-page-hero-top',
  CategoryPageHeroBottom = 'category-page-hero-bottom',
}

export enum ProductItemSlotIds {
  ProductGalleryDetailsSlot1 = 'product-gallery-details-slot-1',
  GalleryItemAdditionalButtons = 'gallery-item-additional-buttons',
}

export enum SliderArrowsPlacement {
  Inside = 0,
  Outside = 1,
}

export enum ScrollNavigationIntervalsOption {
  SINGLE = 0,
  MULTIPLE = 1,
}

export enum SliderScrollBehavior {
  SNAPPING = 0,
  SEAMLESS = 1,
}

export enum TextualOptionType {
  DROPDOWN = 1,
  BUTTONS = 2,
}

export enum ButtonOptionWidth {
  FIT = 1,
  STRETCH = 2,
}

export enum AddToCartFlowType {
  QUICK_VIEW = 0,
  QUICK_ADD = 1,
  DIRECT_ADD = 2,
}

export enum FontTheme {
  Heading1 = 'Title',
  Heading2 = 'Page-title',
  Heading3 = 'Heading-XL',
  Heading4 = 'Heading-L',
  Heading5 = 'Heading-M',
  Heading6 = 'Heading-S',
  Paragraph1 = 'Body-L',
  Paragraph2 = 'Body-M',
  Paragraph3 = 'Body-S',
}

export const widgetLoadedPanoramaEventMap: Partial<Record<StoresWidgetID, FedopsInteraction>> = {
  [StoresWidgetID.GRID_GALLERY]: FedopsInteraction.GridGalleryLoaded,
  [StoresWidgetID.CATEGORY_PAGE]: FedopsInteraction.CategoryPageLoaded,
  [StoresWidgetID.SEARCH_RESULTS_GALLERY]: FedopsInteraction.SearchResultsGalleryLoaded,
  [StoresWidgetID.SEARCH_MODAL_GALLERY]: FedopsInteraction.SearchModalGalleryLoaded,
};
